export default __webpack_public_path__ + "static/big_button_background-7c59f42ac3824f20a31780d1da23b1fb.png";